module.exports = __webpack_public_path__ + "static/media/key.f97690f9.svg";